/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Component, Input } from "@angular/core";

@Component({
	selector: "globalictcc-profile",
	standalone: true,
	imports: [],
	templateUrl: "./profile.component.html",
	styleUrl: "./profile.component.scss"
})
export class ProfileComponent {
	@Input() public username: string = "";
	@Input() public role: string = "";
	@Input() public profilePicUrl: string = "";
}
